export enum StorageKeys {
	TOKEN = "token",
	REFRESH_TOKEN = "refreshToken",
	USER = "user",
  USER_EMAIL = "userEmail",
	TRAFFIC_LAYER_ENABLED = "trafficLayerEnabled",
	MAP_DARK_MODE = "mapDarkMode"
}
